module.exports = __webpack_public_path__ + "static/img/1.cd3b921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quartos/duplo2/1.jpg
// module id = kk3T
// module chunks = 1